module.exports = __webpack_public_path__ + "img/img48.cb0cb2a0.png";